import { observer } from 'mobx-react-lite';
import { Route, Routes } from 'react-router-dom';
import { DashboardLayout } from 'src/components/layouts/DashboardLayout';
import { PrivateRoute } from 'src/components/PrivateRoute';
import { AccountPage } from 'src/pages/AccountPage';
import { DashboardPage } from 'src/pages/DashboardPage';
import { NewConsultationPage } from 'src/pages/NewConsultationPage';
import { NewPatientPage } from 'src/pages/NewPatientPage';
import { SingleConsultationPage } from 'src/pages/SingleConsultationPage';
import { SinglePatientPage } from 'src/pages/SinglePatientPage';

export const RoutesManagerDashboard = observer(function (): React.JSX.Element {
  return (
    <DashboardLayout>
      <Routes>
        <Route path="/account" element={<PrivateRoute><AccountPage /></PrivateRoute>} />
        <Route path="/new-patient" element={<PrivateRoute><NewPatientPage /></PrivateRoute>} />
        <Route
          path="/patients/:patientId/new-consultation"
          element={<PrivateRoute><NewConsultationPage /></PrivateRoute>}
        />
        <Route
          path="/patients/:patientId/consultation/:consultationId"
          element={<PrivateRoute><SingleConsultationPage /></PrivateRoute>}
        />
        <Route
          path="/patients/:patientId/*"
          element={<PrivateRoute><SinglePatientPage /></PrivateRoute>}
        />
        <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      </Routes>
    </DashboardLayout>
  );
});
